import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'

export const fetchItemDetails = fetchGeneralData<any>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/item_details`,
)
